import React, { useContext, createContext, useState, useEffect } from "react";
import { useToast } from "hooks";
import { deleteToken } from "utils/auth";
import { User } from "utils/types";
import { fetchMe } from "api/webservice/users";

export const defaultUser = {
  id: "",
  username: "",
  email: "",
  first_name: "",
  last_name: "",
  has_accepted_eula: false,
  iat: 0,
  createdAt: new Date(),
  privs: 0
};

type UserContextType = {
  user: User;
  setUser: (user: User) => void;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = () => {
  return useContext(UserContext);
};

type Props = {
  children: React.ReactNode;
};

export const UserProvider = ({ children }: Props) => {
  const [user, setUser] = useState(defaultUser);
  const toast = useToast();

  useEffect(() => {
    fetchMe()
      .then(updateUser => {
        //console.log("Updated User", updateUser);
        setUser(updateUser);
      })
      .catch(err => {
        if (err?.response?.status == 419) {
          deleteToken();
          toast({
            title: "Your session has expired",
            description: "Please login again.",
            status: "error"
          });
          window.location.assign("/login");
          return;
        }
      });
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
